import React, { useEffect, useState, useRef } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner } from 'reactstrap';
import { useUser } from '../../hooks';
import 'firebase/compat/firestore';
import { useFirebaseDedup } from '../../hooks/useFirebaseDedup';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import LoadingOverlayExamples from '../../Components/LoadingOverlayExamples';

const TestDashboard = () => {
    const [loading, setLoading] = useState(true);
    const { currentUserId, contractor } = useUser();
    const { dedupRequest } = useFirebaseDedup();
    const isMountedRef = useRef(true);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Test Dashboard" pageTitle="Dashboards" />
                    
                    {/* Full Width Image */}
                    <Row>
                        <Col lg={12} className="px-0">
                            <img 
                                src="/assets/house-pool-1.jpg" 
                                alt="House with Pool" 
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block'
                                }}
                            />
                        </Col>
                    </Row>

                    {/* Loading Overlay Examples */}
                    <Row>
                        <Col lg={12}>
                            <LoadingOverlayExamples />
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default TestDashboard;